import "core-js/modules/es.array.push.js";
export default {
  name: 'PaginationHebei',
  props: {
    totalPages: {
      // 总页数
      type: Number,
      required: true
    },
    currentPage: {
      // 当前页码
      type: Number,
      default: 1
    },
    pageRange: {
      // 展示的页码数量（如左右各显示几个）
      type: Number,
      default: 2
    }
  },
  computed: {
    visiblePages() {
      let start = Math.max(this.currentPage - this.pageRange, 1);
      let end = Math.min(this.currentPage + this.pageRange, this.totalPages);
      if (end - start + 1 < 2 * this.pageRange + 1) {
        if (start === 1) {
          end = Math.min(1 + 2 * this.pageRange, this.totalPages);
        } else if (end === this.totalPages) {
          start = Math.max(this.totalPages - 2 * this.pageRange, 1);
        }
      }
      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    handlePageClick(page) {
      if (page !== this.currentPage) {
        this.$emit('page-change', page);
      }
    },
    goToFirstPage() {
      this.$emit('page-change', 1);
    },
    goToPrevPage() {
      if (this.currentPage > 1) {
        this.$emit('page-change', this.currentPage - 1);
      }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('page-change', this.currentPage + 1);
      }
    },
    goToLastPage() {
      this.$emit('page-change', this.totalPages);
    }
  }
};